import React from "react";
import { loader } from "../..";

interface LocationProps {
  parkedLocation: {
    longitude: number;
    latitude: number;
    location?: string | undefined;
  };
}

const Location: React.FC<LocationProps> = ({
  parkedLocation: { longitude, latitude, location },
}) => {
  const [geoLocation, setGeoLocation] = React.useState<string>("");
  // console.log("location", longitude, latitude, location);
  let map: google.maps.Map;

  loader.importLibrary("maps").then((google) => {
    // console.log("google", google);
    map = new google.Map(document.getElementById("modalmap") as HTMLElement, {
      zoom: 10,
      center: {
        lat: latitude as number,
        lng: longitude as number,
      },
      mapId: "modalmap",
    });
  });

  loader.importLibrary("marker").then((google) => {
    const marker = new google.AdvancedMarkerElement({
      position: {
        lat: latitude as number,
        lng: longitude as number,
      },
      map: map,
      title: "Vehicle is parked here",

      zIndex: 999,
    });
  });

  loader.importLibrary("geocoding").then((google) => {
    const geocoder = new google.Geocoder();
    const latlng = {
      lat: latitude as number,
      lng: longitude as number,
    };
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === "OK" && results?.length) {
        // console.log("results", results[0].formatted_address);
        setGeoLocation(results[0].formatted_address);
      }
    });
  });
  return (
    <div className="flex flex-col md:flex-row w-full gap-10">
      <div className=" w-full md:w-[60%] h-[300px]" id="modalmap"></div>
      <div className=" w-full md:w-[40%]  bg-white flex justify-center items-center">
        <p className=" text-lightGreyText text-base font-Jakarta font-medium text-center w-[80%] border rounded-lg p-5 bg-darkGreen ">
          {/* This vehicle is in a private parking space: <br /> {geoLocation} */}
          This vehicle is parked at: <br /> {geoLocation}
        </p>
      </div>
    </div>
  );
};

export default Location;
